import { render, staticRenderFns } from "./IconArrowChevronDown.vue?vue&type=template&id=2f5a641a"
import script from "./IconArrowChevronDown.vue?vue&type=script&lang=js"
export * from "./IconArrowChevronDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports